import { render, staticRenderFns } from "./NewCountryNotifyModal.vue?vue&type=template&id=55eaff6e&scoped=true&"
import script from "./NewCountryNotifyModal.vue?vue&type=script&lang=ts&"
export * from "./NewCountryNotifyModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewCountryNotifyModal.vue?vue&type=style&index=0&id=55eaff6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eaff6e",
  null
  
)

export default component.exports